var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/reports/assignments" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("reports.sub_header.assignments_tab"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item active" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/reports/classes" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("reports.sub_header.classes_tab"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-27",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm.managingClassList.length === 0
              ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                  _c("div", { staticClass: "empty-list-text" }, [
                    _c("div", {
                      staticClass:
                        "typography--body-2 typography--color-disabled",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("classes.no_classes"))
                      }
                    })
                  ])
                ])
              : _vm._l(_vm.managingClassList, function(cls) {
                  return _c(
                    "div",
                    { key: cls.id, staticClass: "col-sm-6 col-md-4 col-lg-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "card-row" },
                        [_c("ClassItem", { attrs: { cls: cls } })],
                        1
                      )
                    ]
                  )
                })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25c91945", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25c91945","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/classes/views/Classes.vue
// module id = RrWb
// module chunks = 1